module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "dm04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/dm.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The morning after the wedding I awaken inexplicably early, not an easy wakening, but an unsettled stirring from a dark, brooding sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I am blearily spooning freeze-dried coffee into boiled water when the violent slamming of Huda’s door shakes the door to our flat in its frame. I cross to the foyer and peer out the glass inset just in time to see the flustered groom attack the elevator button, pace explosively waiting for it to spring to life, give up in a rage, and go tearing down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The door reopens, and Huda pokes an unveiled head out into the hallway. Her cheeks are tear-streaked. She listens to Ehab’s retreating footsteps, then notices me looking, manages a weak smile, and closes the door again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I remember her face on the first day I saw her. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I know no one in all of Garden City,")]), _vm._v(" she’d said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I pad across the hall in my bare feet, and rap softly on the glass. It does not take too much cajoling to convince Huda to come drink coffee with me.")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a70eb580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780765316578_dm04.vue
// module id = 84
// module chunks = 0